import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage, useField } from 'formik';
import { FormGroup, Label, Spinner } from 'reactstrap';
import axios from 'axios';
import { API_URL } from 'helpers/app_url';
import SafeField from "helpers/SafeField";

const TimeZone = ({ name, label, ...props }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [field, meta] = useField(name);

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem('authUser'));
    const token = obj?.resultData?.bearerToken;

    if (token) {
      axios
        .get(`${API_URL}SysTimeZone/all`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          if (Array.isArray(response.data)) {
            setOptions(response.data);
          } else if (response.data?.resultData) {
            setOptions(response.data.resultData);
          } else {
            setOptions([]);
          }
        })
        .catch((error) => {
          console.error('Error fetching dropdown options:', error);
          setOptions([]);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <FormGroup className="mb-3">
      <Label htmlFor={name}>{label} *</Label>
      {loading ? (
        <Spinner size="sm" color="primary" />
      ) : (
        <SafeField
          as="select"
          name={name}
          className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}`}
          {...props}
        >
          <option value="">Select Time Zone</option>
          {options.map((option) => (
            <option key={option.id} value={option.tzId}>
              {option.tzId}
            </option>
          ))}
        </SafeField>
      )}
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </FormGroup>
  );
};

TimeZone.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default TimeZone;
